import { v4 as uuidv4 } from 'uuid'

export default {
    methods: {
        getNoSubstanceLabel() {
            if (this.$t) {
                return this.$t('Component(FMDEditor):no-substance')
            }
            return 'No substance'
        },
        createEmptySubstance(options = {}) {
            const noSubstance = Boolean(options.noSubstance)
            const label = this.noSubstanceLabel || this.getNoSubstanceLabel()
            const weight = this.normalizeWeight
                ? this.normalizeWeight()
                : { from: null, to: null, fromOperator: 'GTE', toOperator: 'LTE', unit: '% (w/w)' }
            return {
                rowId: uuidv4(),
                substanceId: null,
                substanceName: noSubstance ? label : '',
                substanceCas: '',
                substanceEc: '',
                noSubstance,
                weight,
                weightText: '',
                comment: '',
            }
        },
        mapSubstanceFromInput(sub) {
            const weight = sub.weight || {}
            const normalizedWeight = this.normalizeWeight
                ? this.normalizeWeight(weight)
                : {
                    from: this.normalizeNumber(weight.from),
                    to: this.normalizeNumber(weight.to),
                    fromOperator: this.normalizeOperator(weight.fromOperator, 'GTE'),
                    toOperator: this.normalizeOperator(weight.toOperator, 'LTE'),
                    unit: weight.unit || '% (w/w)',
                }
            return {
                rowId: uuidv4(),
                substanceId: sub.substanceId || (sub.substance && sub.substance.id) || null,
                substanceName: sub.substanceName || (sub.substance && (sub.substance.title || sub.substance.name)) || '',
                substanceCas: sub.substanceCas || (sub.substance && sub.substance.cas) || '',
                substanceEc: sub.substanceEc || (sub.substance && sub.substance.ec) || '',
                noSubstance: false,
                weight: normalizedWeight,
                weightText: this.formatWeightRangeWithOperators(
                    normalizedWeight.from,
                    normalizedWeight.to,
                    normalizedWeight.fromOperator,
                    normalizedWeight.toOperator,
                    normalizedWeight.unit,
                ),
                comment: sub.comment || '',
            }
        },
        normalizeSubstances(input) {
            const substances = (input || []).map(sub => this.mapSubstanceFromInput(sub))
            return substances.length ? substances : [this.createEmptySubstance({ noSubstance: true })]
        },
        applySubstanceSelection(substance, event) {
            if (!event) {
                return null
            }
            if (event.isNoSubstance) {
                substance.noSubstance = true
                substance.substanceId = null
                substance.substanceName = this.noSubstanceLabel || this.getNoSubstanceLabel()
                substance.substanceCas = ''
                substance.substanceEc = ''
                substance.weight = this.normalizeWeight
                    ? this.normalizeWeight()
                    : { from: null, to: null, fromOperator: 'GTE', toOperator: 'LTE', unit: '% (w/w)' }
                substance.weightText = ''
                return null
            }
            substance.noSubstance = false
            substance.substanceId = event.id
            substance.substanceName = event.name || event.title || ''
            substance.substanceCas = event.cas || ''
            substance.substanceEc = event.ec || ''
            return substance.substanceId
        },
    },
}
